import { render, staticRenderFns } from "./bizregion.vue?vue&type=template&id=047cdd5c&scoped=true&"
import script from "./bizregion.vue?vue&type=script&lang=js&"
export * from "./bizregion.vue?vue&type=script&lang=js&"
import style0 from "./bizregion.vue?vue&type=style&index=0&id=047cdd5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047cdd5c",
  null
  
)

export default component.exports